<template>
  <div style="width:100%;height:100%;">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>商家审核</span>
        <div>
          <span style="margin-right:15px">状态类型:</span>
          <el-select v-model="chooseType" placeholder="请选择" @change="choosetTypeChange">
            <el-option v-for="item in typeChooseList" :label="item" :value="item"></el-option>
          </el-select>
        </div>
      </div>
      <el-table :data="tableData" style="width: 100%" height="500px">
        <el-table-column prop="merchant_name" label="商铺名"></el-table-column>
        <el-table-column prop="bank_name" label="收款人"></el-table-column>
        <el-table-column prop="bank_card" label="卡号"></el-table-column>
        <el-table-column prop="amount" label="提现金额"></el-table-column>
        <el-table-column prop="remainder_money" label="店铺余额"></el-table-column>
        <el-table-column prop="date" label="发起时间"></el-table-column>
        <el-table-column prop="name" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-show="scope.row.status==1">已通过</el-tag>
            <el-tag type="info" v-show="scope.row.status==0">待审核</el-tag>
            <el-tag type="warning" v-show="scope.row.status==2">未通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="warning"
              @click="Reject(scope.row)"
              v-show="scope.row.status==0"
            >拒绝</el-button>
            <el-button
              size="mini"
              type="primary"
              v-show="scope.row.status==0"
              @click="pass(scope.row)"
            >已打款</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      typeChooseList: ["已处理", "未处理"],
      tableData: []
    };
  },
  created() {
    this.getTableData();
  },
  methods: {
    Reject(data) {
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `ExamineService/auditFailedCashWithdrawal/${data.id}` // 接口地址
      }).then(res => {
        this.getTableData();
      });
    },
    pass(data) {
      this.$axios({
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `ExamineService/auditSuccessCashWithdrawal/${data.id}` // 接口地址
      }).then(res => {
        console.log(res);
        this.getTableData();
      });
    },
    getTableData() {
      this.$axios({
        method: "get",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        url: `ExamineService/queryCashWithdrawalInfo` // 接口地址
      }).then(res => {
        console.log(res);
        this.tableData = res;
      });
    }
  }
};
</script>

<style>
</style>